/**
 * Códigos de error que devuelve la API.
 * Cada código tiene su traducción en es.json bajo "errors.<CODIGO>"
 */
export enum ErrorCode {
  // Auth Errors
  ERROR_CREDENTIALS = "ERROR_CREDENTIALS",
  TOKEN_INVALID = "TOKEN_INVALID",
  AUTH_FAILED = "AUTH_FAILED",
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  ACCESS_DENIED = "ACCESS_DENIED",
  UNAUTHORIZED = "UNAUTHORIZED",

  // User Errors
  USER_NOT_FOUND = "USER_NOT_FOUND",
  USER_EMAIL_EXISTS = "USER_EMAIL_EXISTS",
  USER_CANNOT_DELETE_SELF = "USER_CANNOT_DELETE_SELF",
  USER_PASSWORD_INCORRECT = "USER_PASSWORD_INCORRECT",
  USER_INACTIVE = "USER_INACTIVE",
  USER_CREATION_FAILED = "USER_CREATION_FAILED",
  USER_UPDATE_FAILED = "USER_UPDATE_FAILED",
  USER_DELETE_FAILED = "USER_DELETE_FAILED",
  DEALER_DOMAIN_ALREADY_EXISTS = "DEALER_DOMAIN_ALREADY_EXISTS",
  CLIENT_USER_ALREADY_LINKED = "CLIENT_USER_ALREADY_LINKED",

  // Dealer Errors
  DEALER_NOT_FOUND = "DEALER_NOT_FOUND",
  DEALER_HAS_USERS = "DEALER_HAS_USERS",

  // General Errors
  VALIDATION_ERROR = "VALIDATION_ERROR",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  CONNECTION_ERROR = "CONNECTION_ERROR",
  ALREADY_EXISTS = "ALREADY_EXISTS",
  NOT_FOUND = "NOT_FOUND",
  CREATION_FAILED = "CREATION_FAILED",

  // Validation Errors - Name
  NAME_REQUIRED = "NAME_REQUIRED",
  NAME_MAX_LENGTH = "NAME_MAX_LENGTH",

  // Validation Errors - Email
  EMAIL_REQUIRED = "EMAIL_REQUIRED",
  EMAIL_INVALID = "EMAIL_INVALID",
  EMAIL_MAX_LENGTH = "EMAIL_MAX_LENGTH",

  // Validation Errors - Password
  PASSWORD_REQUIRED = "PASSWORD_REQUIRED",
  PASSWORD_MIN_LENGTH = "PASSWORD_MIN_LENGTH",
  PASSWORD_UPPERCASE = "PASSWORD_UPPERCASE",
  PASSWORD_LOWERCASE = "PASSWORD_LOWERCASE",
  PASSWORD_DIGIT = "PASSWORD_DIGIT",
  PASSWORD_SPECIAL_CHAR = "PASSWORD_SPECIAL_CHAR",
  PASSWORD_MATCH = "PASSWORD_MATCH",
  PASSWORD_SAME_AS_CURRENT = "PASSWORD_SAME_AS_CURRENT",
  CURRENT_PASSWORD_REQUIRED = "CURRENT_PASSWORD_REQUIRED",
  NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED",
  CONFIRM_PASSWORD_REQUIRED = "CONFIRM_PASSWORD_REQUIRED",

  // Validation Errors - Phone
  PHONE_MAX_LENGTH = "PHONE_MAX_LENGTH",
  PHONE_REQUIRED = "PHONE_REQUIRED",

  // Validation Errors - Role
  ROLE_INVALID = "ROLE_INVALID",
  ROLE_ADMIN_NOT_ALLOWED = "ROLE_ADMIN_NOT_ALLOWED",
  ROLE_DEALER_NOT_ALLOWED = "ROLE_DEALER_NOT_ALLOWED",

  // Validation Errors - Dealer
  DEALER_ID_REQUIRED = "DEALER_ID_REQUIRED",
  DEALER_ID_INVALID = "DEALER_ID_INVALID",
  DEALER_NAME_REQUIRED = "DEALER_NAME_REQUIRED",
  DEALER_NAME_MAX_LENGTH = "DEALER_NAME_MAX_LENGTH",
  DEALER_DESCRIPTION_MAX_LENGTH = "DEALER_DESCRIPTION_MAX_LENGTH",

  // Loan Errors
  LOAN_NOT_FOUND = "LOAN_NOT_FOUND",
  LOAN_ALREADY_CLOSED = "LOAN_ALREADY_CLOSED",
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  MONTH_NUMBER_EXCEEDS_TERM = "MONTH_NUMBER_EXCEEDS_TERM",
  PAYMENT_ALREADY_EXISTS_FOR_MONTH = "PAYMENT_ALREADY_EXISTS_FOR_MONTH",
  SCHEDULE_ROW_NOT_FOUND = "SCHEDULE_ROW_NOT_FOUND",
  PAYMENT_MUST_EXCEED_INTEREST = "PAYMENT_MUST_EXCEED_INTEREST",
  APR_MUST_BE_NON_NEGATIVE = "APR_MUST_BE_NON_NEGATIVE",
  TERM_MONTHS_MUST_BE_POSITIVE = "TERM_MONTHS_MUST_BE_POSITIVE",
  START_DATE_REQUIRED = "START_DATE_REQUIRED",
  MONTH_NUMBER_MUST_BE_POSITIVE = "MONTH_NUMBER_MUST_BE_POSITIVE",
  AMOUNT_MUST_BE_POSITIVE = "AMOUNT_MUST_BE_POSITIVE",
  PAID_DATE_REQUIRED = "PAID_DATE_REQUIRED",
  FUTURE_DATE_NOT_ALLOWED = "FUTURE_DATE_NOT_ALLOWED",
  DEALER_USER_NOT_FOUND = "DEALER_USER_NOT_FOUND",
  PAYMENT_ORDER_VIOLATION = "PAYMENT_ORDER_VIOLATION",
  CANNOT_SKIP_MONTHS = "CANNOT_SKIP_MONTHS",
  MONTHLY_PAYMENT_TOO_LOW = "MONTHLY_PAYMENT_TOO_LOW",
  CANNOT_EDIT_NON_LAST_PAYMENT = "CANNOT_EDIT_NON_LAST_PAYMENT",
  CONTACT_NOT_FOUND = "CONTACT_NOT_FOUND",
  LOAN_CLOSE_REASON_REQUIRED = "LOAN_CLOSE_REASON_REQUIRED",
  LOAN_CLOSE_REASON_MAX_LENGTH = "LOAN_CLOSE_REASON_MAX_LENGTH",
  CLIENT_USER_NOT_FOUND = "CLIENT_USER_NOT_FOUND",
  CLIENT_USER_INVALID_ROLE = "CLIENT_USER_INVALID_ROLE",
  CLIENT_USER_DEALER_MISMATCH = "CLIENT_USER_DEALER_MISMATCH",
  GENERATE_CLIENT_RESOURCE_REQUIRED = "GENERATE_CLIENT_RESOURCE_REQUIRED",

  // Loan Creation Errors
  CALCULATION_TYPE_INVALID = "CALCULATION_TYPE_INVALID",
  CUSTOMER_INFO_REQUIRED = "CUSTOMER_INFO_REQUIRED",
  CUSTOMER_FIRST_NAME_REQUIRED = "CUSTOMER_FIRST_NAME_REQUIRED",
  CUSTOMER_LAST_NAME_REQUIRED = "CUSTOMER_LAST_NAME_REQUIRED",
  LOAN_AMOUNT_REQUIRED = "LOAN_AMOUNT_REQUIRED",
  LOAN_AMOUNT_MUST_BE_POSITIVE = "LOAN_AMOUNT_MUST_BE_POSITIVE",
  APR_REQUIRED = "APR_REQUIRED",
  MONTHLY_PAYMENT_REQUIRED = "MONTHLY_PAYMENT_REQUIRED",
  MONTHLY_PAYMENT_MUST_BE_POSITIVE = "MONTHLY_PAYMENT_MUST_BE_POSITIVE",
  TERM_MONTHS_REQUIRED = "TERM_MONTHS_REQUIRED",
  SCHEDULE_TYPE_INVALID = "SCHEDULE_TYPE_INVALID",
  ADDRESS_MAX_LENGTH = "ADDRESS_MAX_LENGTH",
  CITY_MAX_LENGTH = "CITY_MAX_LENGTH",
  STATE_MAX_LENGTH = "STATE_MAX_LENGTH",
  ZIP_CODE_MAX_LENGTH = "ZIP_CODE_MAX_LENGTH",
  MONTH_NUMBER_REQUIRED = "MONTH_NUMBER_REQUIRED",
  AMOUNT_REQUIRED = "AMOUNT_REQUIRED",
  PAYMENT_TOO_LOW_TO_AMORTIZE = "PAYMENT_TOO_LOW_TO_AMORTIZE",

  // Contact Errors
  CONTACT_DUPLICATE_ID_NUMBER = "CONTACT_DUPLICATE_ID_NUMBER",
  CONTACT_ID_NUMBER_REQUIRED = "CONTACT_ID_NUMBER_REQUIRED",
  CONTACT_DATE_OF_BIRTH_REQUIRED = "CONTACT_DATE_OF_BIRTH_REQUIRED",
  CONTACT_MINIMUM_ADDRESSES_REQUIRED = "CONTACT_MINIMUM_ADDRESSES_REQUIRED",
  CONTACT_MINIMUM_METHODS_REQUIRED = "CONTACT_MINIMUM_METHODS_REQUIRED",
  CONTACT_MINIMUM_EMPLOYMENTS_REQUIRED = "CONTACT_MINIMUM_EMPLOYMENTS_REQUIRED",
  CONTACT_MINIMUM_REFERENCES_REQUIRED = "CONTACT_MINIMUM_REFERENCES_REQUIRED",

  // Vehicle Errors
  VEHICLE_VIN_REQUIRED = "VEHICLE_VIN_REQUIRED",
  VEHICLE_VIN_INVALID_FORMAT = "VEHICLE_VIN_INVALID_FORMAT",
  VEHICLE_NOT_FOUND = "VEHICLE_NOT_FOUND",
  VEHICLE_ALREADY_EXISTS = "VEHICLE_ALREADY_EXISTS",
  VEHICLE_API_FETCH_FAILED = "VEHICLE_API_FETCH_FAILED",
  VEHICLE_API_COOLDOWN_ACTIVE = "VEHICLE_API_COOLDOWN_ACTIVE",

  // Garage Errors
  GARAGE_NOT_FOUND = "GARAGE_NOT_FOUND",
  GARAGE_UNAUTHORIZED = "GARAGE_UNAUTHORIZED",
  GARAGE_NAME_REQUIRED = "GARAGE_NAME_REQUIRED",
  GARAGE_NAME_MAX_LENGTH = "GARAGE_NAME_MAX_LENGTH",
  GARAGE_INVALID_FOR_DEALER = "GARAGE_INVALID_FOR_DEALER",

  // Contract Errors
  CONTRACT_NOT_FOUND = "CONTRACT_NOT_FOUND",
  CONTRACT_NOT_PENDING = "CONTRACT_NOT_PENDING",
  CONTRACT_CONCURRENT_MODIFICATION = "CONTRACT_CONCURRENT_MODIFICATION",
  CONTRACT_INVALID_CONTACT = "CONTRACT_INVALID_CONTACT",
  CONTRACT_INVALID_VEHICLE = "CONTRACT_INVALID_VEHICLE",
  CONTRACT_INVALID_DYNAMIC_FIELD = "CONTRACT_INVALID_DYNAMIC_FIELD",
  CONTRACT_AMOUNT_TO_FINANCE_INVALID = "CONTRACT_AMOUNT_TO_FINANCE_INVALID",
  CONTRACT_CANCEL_REASON_REQUIRED = "CONTRACT_CANCEL_REASON_REQUIRED",
  VEHICLE_ALREADY_ASSIGNED_TO_SALE_CONTRACT = "VEHICLE_ALREADY_ASSIGNED_TO_SALE_CONTRACT",
  VEHICLE_ALREADY_ASSIGNED_TO_ACTIVE_LOAN_OR_CONTRACT = "VEHICLE_ALREADY_ASSIGNED_TO_ACTIVE_LOAN_OR_CONTRACT",

  // Deferred Down Payment Errors
  DEFERRED_PAYMENT_CONTRACT_NOT_ELIGIBLE = "DEFERRED_PAYMENT_CONTRACT_NOT_ELIGIBLE",
  DEFERRED_PAYMENT_AMOUNT_MUST_BE_POSITIVE = "DEFERRED_PAYMENT_AMOUNT_MUST_BE_POSITIVE",
  DEFERRED_PAYMENT_EXCEEDS_DOWN_PAYMENT = "DEFERRED_PAYMENT_EXCEEDS_DOWN_PAYMENT",
  DEFERRED_PAYMENT_NOT_FOUND = "DEFERRED_PAYMENT_NOT_FOUND",
  DEFERRED_PAYMENT_NOT_EDITABLE = "DEFERRED_PAYMENT_NOT_EDITABLE",
  DEFERRED_PAYMENT_CANNOT_DELETE_ON_APPROVED_CONTRACT = "DEFERRED_PAYMENT_CANNOT_DELETE_ON_APPROVED_CONTRACT",
  DEFERRED_PAYMENT_ALREADY_PAID = "DEFERRED_PAYMENT_ALREADY_PAID",
  DEFERRED_PAYMENT_ALREADY_CANCELLED = "DEFERRED_PAYMENT_ALREADY_CANCELLED",
}

/**
 * Mapeo de código de error a clave de traducción en es.json
 */
export const errorMessages: Record<string, string> = {
  // Auth Errors
  [ErrorCode.ERROR_CREDENTIALS]: "errors.invalid-credentials",
  [ErrorCode.TOKEN_INVALID]: "errors.token-invalid",
  [ErrorCode.AUTH_FAILED]: "errors.auth-failed",
  [ErrorCode.INVALID_CREDENTIALS]: "errors.invalid-credentials",
  [ErrorCode.ACCESS_DENIED]: "errors.access-denied",
  [ErrorCode.UNAUTHORIZED]: "session-expired",

  // User Errors
  [ErrorCode.USER_NOT_FOUND]: "errors.user-not-found",
  [ErrorCode.USER_EMAIL_EXISTS]: "errors.user-exists",
  [ErrorCode.USER_CANNOT_DELETE_SELF]: "errors.user-cannot-delete-self",
  [ErrorCode.USER_PASSWORD_INCORRECT]: "errors.user-password-incorrect",
  [ErrorCode.USER_INACTIVE]: "errors.user-inactive",
  [ErrorCode.USER_CREATION_FAILED]: "errors.user-creation-failed",
  [ErrorCode.USER_UPDATE_FAILED]: "errors.user-update-failed",
  [ErrorCode.USER_DELETE_FAILED]: "errors.user-delete-failed",
  [ErrorCode.DEALER_DOMAIN_ALREADY_EXISTS]: "errors.dealer-domain-already-exists",
  [ErrorCode.CLIENT_USER_ALREADY_LINKED]: "errors.client-user-already-linked",

  // Dealer Errors
  [ErrorCode.DEALER_NOT_FOUND]: "errors.dealer-not-found",
  [ErrorCode.DEALER_HAS_USERS]: "errors.dealer-has-users",

  // General Errors
  [ErrorCode.VALIDATION_ERROR]: "errors.validation",
  [ErrorCode.INTERNAL_SERVER_ERROR]: "errors.internal-server-error",
  [ErrorCode.INTERNAL_ERROR]: "errors.internal-error",
  [ErrorCode.CONNECTION_ERROR]: "errors.connection-error",
  [ErrorCode.ALREADY_EXISTS]: "errors.already-exists",
  [ErrorCode.NOT_FOUND]: "errors.not-found",
  [ErrorCode.CREATION_FAILED]: "errors.creation-failed",

  // Validation Errors - Name
  [ErrorCode.NAME_REQUIRED]: "errors.name-required",
  [ErrorCode.NAME_MAX_LENGTH]: "errors.name-max-length",

  // Validation Errors - Email
  [ErrorCode.EMAIL_REQUIRED]: "errors.email-required",
  [ErrorCode.EMAIL_INVALID]: "errors.email-invalid",
  [ErrorCode.EMAIL_MAX_LENGTH]: "errors.email-max-length",

  // Validation Errors - Password
  [ErrorCode.PASSWORD_REQUIRED]: "errors.password-required",
  [ErrorCode.PASSWORD_MIN_LENGTH]: "errors.password-min-length",
  [ErrorCode.PASSWORD_UPPERCASE]: "errors.password-uppercase",
  [ErrorCode.PASSWORD_LOWERCASE]: "errors.password-lowercase",
  [ErrorCode.PASSWORD_DIGIT]: "errors.password-digit",
  [ErrorCode.PASSWORD_SPECIAL_CHAR]: "errors.password-special-char",
  [ErrorCode.PASSWORD_MATCH]: "errors.password-match",
  [ErrorCode.PASSWORD_SAME_AS_CURRENT]: "errors.password-same-as-current",
  [ErrorCode.CURRENT_PASSWORD_REQUIRED]: "errors.current-password-required",
  [ErrorCode.NEW_PASSWORD_REQUIRED]: "errors.new-password-required",
  [ErrorCode.CONFIRM_PASSWORD_REQUIRED]: "errors.confirm-password-required",

  // Validation Errors - Phone
  [ErrorCode.PHONE_MAX_LENGTH]: "errors.phone-max-length",
  [ErrorCode.PHONE_REQUIRED]: "errors.phone-required",

  // Validation Errors - Role
  [ErrorCode.ROLE_INVALID]: "errors.role-invalid",
  [ErrorCode.ROLE_ADMIN_NOT_ALLOWED]: "errors.role-admin-not-allowed",
  [ErrorCode.ROLE_DEALER_NOT_ALLOWED]: "errors.role-dealer-not-allowed",

  // Validation Errors - Dealer
  [ErrorCode.DEALER_ID_REQUIRED]: "errors.dealer-id-required",
  [ErrorCode.DEALER_ID_INVALID]: "errors.dealer-id-invalid",
  [ErrorCode.DEALER_NAME_REQUIRED]: "errors.dealer-name-required",
  [ErrorCode.DEALER_NAME_MAX_LENGTH]: "errors.dealer-name-max-length",
  [ErrorCode.DEALER_DESCRIPTION_MAX_LENGTH]: "errors.dealer-description-max-length",

  // Loan Errors
  [ErrorCode.LOAN_NOT_FOUND]: "errors.loan-not-found",
  [ErrorCode.LOAN_ALREADY_CLOSED]: "errors.loan-already-closed",
  [ErrorCode.CUSTOMER_NOT_FOUND]: "errors.customer-not-found",
  [ErrorCode.MONTH_NUMBER_EXCEEDS_TERM]: "errors.month-number-exceeds-term",
  [ErrorCode.PAYMENT_ALREADY_EXISTS_FOR_MONTH]: "errors.payment-already-exists-for-month",
  [ErrorCode.SCHEDULE_ROW_NOT_FOUND]: "errors.schedule-row-not-found",
  [ErrorCode.PAYMENT_MUST_EXCEED_INTEREST]: "errors.payment-must-exceed-interest",
  [ErrorCode.APR_MUST_BE_NON_NEGATIVE]: "errors.apr-must-be-non-negative",
  [ErrorCode.TERM_MONTHS_MUST_BE_POSITIVE]: "errors.term-months-must-be-positive",
  [ErrorCode.START_DATE_REQUIRED]: "errors.start-date-required",
  [ErrorCode.MONTH_NUMBER_MUST_BE_POSITIVE]: "errors.month-number-must-be-positive",
  [ErrorCode.AMOUNT_MUST_BE_POSITIVE]: "errors.amount-must-be-positive",
  [ErrorCode.PAID_DATE_REQUIRED]: "errors.paid-date-required",
  [ErrorCode.FUTURE_DATE_NOT_ALLOWED]: "errors.future-date-not-allowed",
  [ErrorCode.DEALER_USER_NOT_FOUND]: "errors.dealer-user-not-found",
  [ErrorCode.PAYMENT_ORDER_VIOLATION]: "errors.payment-order-violation",
  [ErrorCode.CANNOT_SKIP_MONTHS]: "errors.cannot-skip-months",
  [ErrorCode.MONTHLY_PAYMENT_TOO_LOW]: "errors.monthly-payment-too-low",
  [ErrorCode.CANNOT_EDIT_NON_LAST_PAYMENT]: "errors.cannot-edit-non-last-payment",
  [ErrorCode.LOAN_CLOSE_REASON_REQUIRED]: "errors.loan-close-reason-required",
  [ErrorCode.LOAN_CLOSE_REASON_MAX_LENGTH]: "errors.loan-close-reason-max-length",
  [ErrorCode.CLIENT_USER_NOT_FOUND]: "errors.client-user-not-found",
  [ErrorCode.CLIENT_USER_INVALID_ROLE]: "errors.client-user-invalid-role",
  [ErrorCode.CLIENT_USER_DEALER_MISMATCH]: "errors.client-user-dealer-mismatch",
  [ErrorCode.GENERATE_CLIENT_RESOURCE_REQUIRED]: "errors.generate-client-resource-required",

  // Loan Creation Errors
  [ErrorCode.CALCULATION_TYPE_INVALID]: "errors.calculation-type-invalid",
  [ErrorCode.CUSTOMER_INFO_REQUIRED]: "errors.customer-info-required",
  [ErrorCode.CUSTOMER_FIRST_NAME_REQUIRED]: "errors.customer-first-name-required",
  [ErrorCode.CUSTOMER_LAST_NAME_REQUIRED]: "errors.customer-last-name-required",
  [ErrorCode.LOAN_AMOUNT_REQUIRED]: "errors.loan-amount-required",
  [ErrorCode.LOAN_AMOUNT_MUST_BE_POSITIVE]: "errors.loan-amount-must-be-positive",
  [ErrorCode.APR_REQUIRED]: "errors.apr-required",
  [ErrorCode.MONTHLY_PAYMENT_REQUIRED]: "errors.monthly-payment-required",
  [ErrorCode.MONTHLY_PAYMENT_MUST_BE_POSITIVE]: "errors.monthly-payment-must-be-positive",
  [ErrorCode.TERM_MONTHS_REQUIRED]: "errors.term-months-required",
  [ErrorCode.SCHEDULE_TYPE_INVALID]: "errors.schedule-type-invalid",
  [ErrorCode.ADDRESS_MAX_LENGTH]: "errors.address-max-length",
  [ErrorCode.CITY_MAX_LENGTH]: "errors.city-max-length",
  [ErrorCode.STATE_MAX_LENGTH]: "errors.state-max-length",
  [ErrorCode.ZIP_CODE_MAX_LENGTH]: "errors.zip-code-max-length",
  [ErrorCode.MONTH_NUMBER_REQUIRED]: "errors.month-number-required",
  [ErrorCode.AMOUNT_REQUIRED]: "errors.amount-required",
  [ErrorCode.PAYMENT_TOO_LOW_TO_AMORTIZE]: "errors.payment-too-low-to-amortize",

  // Contact Errors
  [ErrorCode.CONTACT_DUPLICATE_ID_NUMBER]: "errors.contact-duplicate-id-number",
  [ErrorCode.CONTACT_ID_NUMBER_REQUIRED]: "errors.contact-id-number-required",
  [ErrorCode.CONTACT_DATE_OF_BIRTH_REQUIRED]: "errors.contact-date-of-birth-required",
  [ErrorCode.CONTACT_MINIMUM_ADDRESSES_REQUIRED]: "errors.contact-minimum-addresses-required",
  [ErrorCode.CONTACT_MINIMUM_METHODS_REQUIRED]: "errors.contact-minimum-methods-required",
  [ErrorCode.CONTACT_MINIMUM_EMPLOYMENTS_REQUIRED]: "errors.contact-minimum-employments-required",
  [ErrorCode.CONTACT_MINIMUM_REFERENCES_REQUIRED]: "errors.contact-minimum-references-required",
  [ErrorCode.CONTACT_NOT_FOUND]: "errors.contact-not-found",

  // Vehicle Errors
  [ErrorCode.VEHICLE_VIN_REQUIRED]: "errors.vehicle-vin-required",
  [ErrorCode.VEHICLE_VIN_INVALID_FORMAT]: "errors.vehicle-vin-invalid-format",
  [ErrorCode.VEHICLE_NOT_FOUND]: "errors.vehicle-not-found",
  [ErrorCode.VEHICLE_ALREADY_EXISTS]: "errors.vehicle-already-exists",
  [ErrorCode.VEHICLE_API_FETCH_FAILED]: "errors.vehicle-api-fetch-failed",
  [ErrorCode.VEHICLE_API_COOLDOWN_ACTIVE]: "errors.vehicle-api-cooldown-active",

  // Garage Errors
  [ErrorCode.GARAGE_NOT_FOUND]: "errors.garage-not-found",
  [ErrorCode.GARAGE_UNAUTHORIZED]: "errors.garage-unauthorized",
  [ErrorCode.GARAGE_NAME_REQUIRED]: "errors.garage-name-required",
  [ErrorCode.GARAGE_NAME_MAX_LENGTH]: "errors.garage-name-max-length",
  [ErrorCode.GARAGE_INVALID_FOR_DEALER]: "errors.garage-invalid-for-dealer",

  // Contract Errors
  [ErrorCode.CONTRACT_NOT_FOUND]: "errors.contract-not-found",
  [ErrorCode.CONTRACT_NOT_PENDING]: "errors.contract-not-pending",
  [ErrorCode.CONTRACT_CONCURRENT_MODIFICATION]: "errors.contract-concurrent-modification",
  [ErrorCode.CONTRACT_INVALID_CONTACT]: "errors.contract-invalid-contact",
  [ErrorCode.CONTRACT_INVALID_VEHICLE]: "errors.contract-invalid-vehicle",
  [ErrorCode.CONTRACT_INVALID_DYNAMIC_FIELD]: "errors.contract-invalid-dynamic-field",
  [ErrorCode.CONTRACT_AMOUNT_TO_FINANCE_INVALID]: "errors.contract-amount-to-finance-invalid",
  [ErrorCode.CONTRACT_CANCEL_REASON_REQUIRED]: "errors.contract-cancel-reason-required",
  [ErrorCode.VEHICLE_ALREADY_ASSIGNED_TO_SALE_CONTRACT]: "errors.vehicle-already-assigned-to-sale-contract",
  [ErrorCode.VEHICLE_ALREADY_ASSIGNED_TO_ACTIVE_LOAN_OR_CONTRACT]: "errors.vehicle-already-assigned-to-active-loan-or-contract",

  // Deferred Down Payment Errors
  [ErrorCode.DEFERRED_PAYMENT_CONTRACT_NOT_ELIGIBLE]: "errors.deferred-payment-contract-not-eligible",
  [ErrorCode.DEFERRED_PAYMENT_AMOUNT_MUST_BE_POSITIVE]: "errors.deferred-payment-amount-must-be-positive",
  [ErrorCode.DEFERRED_PAYMENT_EXCEEDS_DOWN_PAYMENT]: "errors.deferred-payment-exceeds-down-payment",
  [ErrorCode.DEFERRED_PAYMENT_NOT_FOUND]: "errors.deferred-payment-not-found",
  [ErrorCode.DEFERRED_PAYMENT_NOT_EDITABLE]: "errors.deferred-payment-not-editable",
  [ErrorCode.DEFERRED_PAYMENT_CANNOT_DELETE_ON_APPROVED_CONTRACT]: "errors.deferred-payment-cannot-delete-on-approved-contract",
  [ErrorCode.DEFERRED_PAYMENT_ALREADY_PAID]: "errors.deferred-payment-already-paid",
  [ErrorCode.DEFERRED_PAYMENT_ALREADY_CANCELLED]: "errors.deferred-payment-already-cancelled",
};

export function getErrorMessageKey(errorCode: string): string {
  return errorMessages[errorCode] || "errors.unexpected";
}
